var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdvanceFilterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.6001 3.5999C3.6001 2.93716 4.13736 2.3999 4.8001 2.3999H19.2001C19.8628 2.3999 20.4001 2.93716 20.4001 3.5999V7.1999C20.4001 7.51816 20.2737 7.82339 20.0486 8.04843L14.4001 13.697V17.9999C14.4001 18.3182 14.2737 18.6234 14.0486 18.8484L11.6486 21.2484C11.3054 21.5916 10.7893 21.6943 10.3409 21.5086C9.89247 21.3228 9.6001 20.8853 9.6001 20.3999V13.697L3.95157 8.04843C3.72653 7.82339 3.6001 7.51816 3.6001 7.1999V3.5999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvanceFilterIcon);
export default __webpack_public_path__ + "static/media/advance-filter-icon.01c6c20bfeaf354c10e88c5554779398.svg";
export { ForwardRef as ReactComponent };